import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import { chunk } from 'lodash';
import User from '../User';
import styles from './styles';

export const UserListComponent = ({
  users,
  classes,
  maxUsers,
  ...props
}) => {
  const [
    displayUsers = [],
    extraUsers,
  ] = chunk(users, maxUsers || users.length);

  return (
    <div className={classes.root}>
      {
        displayUsers.map((user) => (
          <div key={user.email} className={classes.container}>
            <User user={user} {...props} />
          </div>
        ))
      }
      {
        !!extraUsers
          && (
            <div className={classes.moreContainer}>
              +{extraUsers.length}
            </div>
          )
      }
    </div>
  );
};

UserListComponent.propTypes = {
  users: PropTypes.array,
  classes: PropTypes.object,
  maxUsers: PropTypes.number,
};

UserListComponent.defaultProps = {
  users: [],
  classes: {},
  maxUsers: null,
};

export default withStyles(styles)(UserListComponent);
